import { Grid, Stack, CircularProgress } from "@mui/material";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { DashboardCard } from "Dashboard/Components/DashboardCard";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { AccessRightCodes } from "Infrastructure/Models/AccessRightCodes";
import DnsIcon from "@mui/icons-material/Dns";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SmartToyIcon from "@mui/icons-material/SmartToy";

type DashboardItem = {
	title: string;
	description: string;
	icon: React.ReactNode;
	to: string;
	requiredAccessRight?: string;
};

const dashboardItems: DashboardItem[] = [
	{
		title: "Správa instancí",
		description: "Správa NSure instancí, nastavení a konfigurace",
		icon: <DnsIcon />,
		to: getPath(AppRouting.InstanceManagement),
		requiredAccessRight: AccessRightCodes.InstanceManagement,
	},
	{
		title: "Správa číselníků",
		description: "Správa souborů číselníků, zdrojů dat a importů",
		icon: <ListAltIcon />,
		to: getPath(AppRouting.CodelistManagement),
		requiredAccessRight: AccessRightCodes.CodelistManagement,
	},
	{
		title: "AI usage",
		description: "Přehled využití AI na jednotlivých instancích po měsících",
		icon: <SmartToyIcon />,
		to: getPath(AppRouting.AiUsage),
		requiredAccessRight: AccessRightCodes.InstanceManagement,
	},
];

export const DashboardPage: React.FunctionComponent = () => {
	const { data, isLoading } = useUserInfoQuery();

	const userAccessRights = data?.status === 200 ? data.data.accessRightCodes ?? [] : [];

	const visibleItems = dashboardItems.filter((item) => {
		if (!item.requiredAccessRight) {
			return true;
		}
		return userAccessRights.includes(item.requiredAccessRight);
	});

	if (isLoading) {
		return (
			<AuthenticatedLayout title="Dashboard">
				<Stack alignItems="center" justifyContent="center" minHeight="200px">
					<CircularProgress />
				</Stack>
			</AuthenticatedLayout>
		);
	}

	return (
		<AuthenticatedLayout title="Dashboard">
			<Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}>
				{visibleItems.map((item) => (
					<Grid item xs={12} sm={6} md={4} lg={3} key={item.to}>
						<DashboardCard
							title={item.title}
							description={item.description}
							icon={item.icon}
							to={item.to}
						/>
					</Grid>
				))}
			</Grid>
		</AuthenticatedLayout>
	);
};
